import dateTimeMixin from '@/mixins/dateTimeMixin';
import dateUtils from '@/common/dateUtils';

export const createMail = ({ absenceItem, address, reason, absenceDuration, remark, userName }) => {
  let { mx_formatIsoDateStringAsLocaleDateTime } = dateTimeMixin.methods;
  let dutyFrom = absenceItem.dutyFrom
    ? mx_formatIsoDateStringAsLocaleDateTime(absenceItem.dutyFrom)
    : absenceItem.reportedAtTime
    ? mx_formatIsoDateStringAsLocaleDateTime(absenceItem.reportedAtTime)
    : null;
  console.debug('createMail');

  let subject = `Absenzmeldung ${absenceItem.vbzNr} ${userName} ${dutyFrom ? dutyFrom : ''}`;
  let body = `
Grund: ${reason}
${absenceItem.absenceDurationId ? `Voraussichtliche Dauer: ${absenceDuration}\t\t ` : ''}

Bemerkung: ${remark}
Aussage FDM:
VBZ Nr.: ${absenceItem.vbzNr}
Mitarbeiter: ${userName}

Zugeteilter Dienst: ${absenceItem.duty}
Dienst von ${dateUtils.formatTime(absenceItem.dutyFrom)} bis ${dateUtils.formatTime(absenceItem.dutyUntil)}


Eingang Meldung: ${mx_formatIsoDateStringAsLocaleDateTime(absenceItem.reportedAtTime)}
Disponent: ${absenceItem.disponent ? absenceItem.disponent : ''}
`;
  let mailTo = `mailto:${address}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  console.debug('address', address);
  return { subject, body, mailTo };
};
